module.exports = __webpack_public_path__ + "img/duplicate-workflow.5502956e.svg";